/* eslint-disable consistent-return */
import { useEffect, useState } from "react";
import { getPhrase } from "../richContent/getPhrase";
import { useAppDispatch } from "../store/hooks";
import useFeedback from "../useFeedback";
import { refreshFeedback } from "../contents/underlines/writingAlertsSlice";
import { loading, updateDocId } from "../editorsSlice";
import { FeedbackWithRange } from "../writeshift/WriteShift";

export default function useDispatchFeedback(
  editorElement: Element,
  editorContent: string,
  editorId: number,
  shouldRefresh: boolean
): void {
  const [debounceMs, setDebounceMs] = useState(100);
  editorElement.addEventListener("keyup", () => {
    setDebounceMs(1500);
  });
  const { feedback, isLoading, docId, scoreId } = useFeedback(
    editorContent,
    debounceMs,
    shouldRefresh
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(loading({ editorId, isLoading }));
  }, [dispatch, editorId, isLoading]);

  useEffect(() => {
    if (!scoreId) {
      return;
    }

    const feedbackWithPhrase: {
      feedback: FeedbackWithRange;
      phrase: string;
    }[] = [];

    for (const f of feedback) {
      const phrase = getPhrase(f.highlightRange, editorElement);
      if (phrase) {
        feedbackWithPhrase.push({
          feedback: f,
          phrase,
        });
      } else {
        console.warn("No phrase available for", f, "in", editorElement);
      }
    }
    dispatch(
      refreshFeedback({
        editorId,
        scoreId,
        feedbackWithPhrase,
      })
    );
    if (docId) {
      dispatch(updateDocId({ editorId, docId }));
    }
    return () => {
      editorElement.removeEventListener("keyup", () => {
        if (debounceMs !== 100) {
          setDebounceMs(100);
        }
      });
    };
  }, [feedback, dispatch, editorId, editorElement, docId, scoreId, debounceMs]);
}
